const sortPerformancesByDate = performances => (
    performances.sort(function(a, b) {
        const aUtc = a.timeUtc
        const bUtc = b.timeUtc 

        return bUtc > aUtc ? -1 : bUtc < aUtc ? 1 : 0
    })
)

export default sortPerformancesByDate